import { render } from "./ComboBoxComponent.vue?vue&type=template&id=0cf4eadd"
import script from "./ComboBoxComponent.vue?vue&type=script&lang=js"
export * from "./ComboBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__